import React from "react";
import { Grid, Typography, Button } from "@mui/material";
import MainImage from "../../assets/logo2 edit.mp4";
import Coin from "../../assets/coin.png";
import { Container } from "@mui/material";

import "./index.css";
export default function () {
  return (
    <>
      <Container>
        <Grid container className="main-container">
          <Grid item lg={6} md={6} sm={12} xs={12} className="main-img-div">
            <Grid className="img-media-div">
              {/* <img src={MainImage} className="main-image" /> */}
              <video
                src={MainImage}
                type="video/mp4"
                width="600"
                height="580"
                autoPlay
                muted
                loop
                className="main-image"
              />
            </Grid>
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12} className="main-text-div">
            <Typography className="main-text-1">
              Terra Treasury
              <Typography className="main-text-1">
                First Decentralized
                <Typography className="main-text-2">
                  3rd gen. Savings
                  <Typography className="main-text-3"> Protocol</Typography>
                </Typography>
              </Typography>
            </Typography>
            <Grid className="main-buttons-div">
              <Button className="main-button">
                <Typography className="main-button-text-1">
                  Earn 34.87% APY
                </Typography>
              </Button>
              <Button className="main-button-2">
                <img src={Coin} />
                <Typography className="main-button-text-2">Save Now</Typography>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
